import gsap from "gsap"

export default function fade(oldContainer, newContainer, done) {
	
    const tl = gsap.timeline()
    tl.to(oldContainer, {
        duration: 0.3,
        opacity: 0,
        ease: "power2.out",
        onComplete:(() => { window.scrollTo(0,0,0) })
    })
    tl.to(oldContainer, {
        duration: 0,
        display: 'none'
    })
    tl.to(newContainer, {
        duration: 0,
        opacity : 0,
        visibility: 'visible'
    })
    tl.to(newContainer, {
        duration: 0.3,
        opacity: 1,
        ease: "power2.in",
    })
    tl.then(done)

}